import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Form } from 'react-bootstrap';

import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '../forms/Checkbox';
import Password from '../forms/Password';
import FloatingLabelTextInput from '../forms/FloatingLabelTextInput';
import { doRegister, doSocialConnect } from '../../actions/auth';
import { setLoginModalStep } from '../../../sell/actions/sell-tickets';
import { setFormFieldValue } from '../../../cart/actions/forms';
import { selectCartFormData } from '../../../cart/selectors';
import { localeSelector } from '../../selectors/i18n';
import { LOGIN_STEP_1 } from '../../../sell/constants/modal';
import { CONNECT_IABILET } from '../../../sell/api/config';
import {
    USER_AGREE_TERMS_FIELD, USER_CONFIRM_EMAIL_FIELD, USER_EMAIL_FIELD, USER_FIRST_NAME_FIELD, USER_FORM,
    USER_LAST_NAME_FIELD, USER_PASSWORD_FIELD, USER_PHONE_FIELD,
} from '../../../cart/reducers/features/user';

import IABILET_LOGO from '../../assets/img/iabilet-blue.svg';

const LoginStep4 = ({ auth, goToNextStep, targetPath }) => {
    const locale = useSelector(localeSelector);
    const dispatch = useDispatch();
    const inputs = useSelector((state) => selectCartFormData(state, USER_FORM));

    const register = (e) => {
        e.preventDefault();
        dispatch(doRegister(inputs, goToNextStep));
    };

    return (
        <div className="login-container">
            <h4 className="mb-0"><FormattedMessage id="sing_up"/></h4>
            <p className="mb-3">
                <FormattedMessage id="already_a_member"/>
                <Button variant="link" className="ms-md-2 m-0 p-0 text-decoration-none fs-6 border-0"
                    onClick={() => dispatch(setLoginModalStep(LOGIN_STEP_1))}><FormattedMessage id="sing_in"/>
                </Button>
            </p>
            <div className="connect__btns d-grid gap-2 mb-4">
                <Button variant="outline-dark" size="lg"
                    onClick={() => doSocialConnect(CONNECT_IABILET, targetPath)}>
                    <FormattedMessage id="connect_with"/>
                    <img src={IABILET_LOGO} alt="IaBilet" className="logo-iabilet img-fluid ms-2"/>
                </Button>
            </div>

            <p className="text-muted text-center mb-4"><FormattedMessage id="register_modal_alternative"/></p>
            <Form onSubmit={register}>
                <FloatingLabelTextInput controlId={USER_FIRST_NAME_FIELD} label={<FormattedMessage id="login_modal_first_name"/>}
                    isInvalid={!inputs[USER_FIRST_NAME_FIELD].isValid}
                    value={inputs[USER_FIRST_NAME_FIELD].value}
                    onChange={(e) => {
                        dispatch(setFormFieldValue(USER_FORM, USER_FIRST_NAME_FIELD, e.target.value));
                    }}
                    errorMessage={inputs[USER_FIRST_NAME_FIELD].errorMessage}
                />
                <FloatingLabelTextInput controlId={USER_LAST_NAME_FIELD} label={<FormattedMessage id="login_modal_last_name"/>}
                    isInvalid={!inputs[USER_LAST_NAME_FIELD].isValid}
                    value={inputs[USER_LAST_NAME_FIELD].value}
                    onChange={(e) => {
                        dispatch(setFormFieldValue(USER_FORM, USER_LAST_NAME_FIELD, e.target.value));
                    }}
                    errorMessage={inputs[USER_LAST_NAME_FIELD].errorMessage}
                />
                <FloatingLabelTextInput controlId={USER_PHONE_FIELD} label={<FormattedMessage id="login_modal_mobile_phone"/>}
                    isInvalid={!inputs[USER_PHONE_FIELD].isValid}
                    value={inputs[USER_PHONE_FIELD].value}
                    onChange={(e) => {
                        dispatch(setFormFieldValue(USER_FORM, USER_PHONE_FIELD, e.target.value));
                    }}
                    errorMessage={inputs[USER_PHONE_FIELD].errorMessage}
                />
                <FloatingLabelTextInput controlId={USER_EMAIL_FIELD} label={<FormattedMessage id="login_modal_email_placeholder"/>}
                    isInvalid={!inputs[USER_EMAIL_FIELD].isValid}
                    value={inputs[USER_EMAIL_FIELD].value}
                    autoComplete="user_email"
                    onChange={(e) => {
                        dispatch(setFormFieldValue(USER_FORM, USER_EMAIL_FIELD, e.target.value));
                    }}
                    onPaste={(e) => {
                        e.preventDefault();
                    }}
                    errorMessage={inputs[USER_EMAIL_FIELD].errorMessage}
                />
                <FloatingLabelTextInput controlId={USER_CONFIRM_EMAIL_FIELD}
                    label={<FormattedMessage id="login_modal_confirm_email_placeholder"/>}
                    isInvalid={!inputs[USER_CONFIRM_EMAIL_FIELD].isValid}
                    value={inputs[USER_CONFIRM_EMAIL_FIELD].value}
                    autoComplete={USER_CONFIRM_EMAIL_FIELD}
                    onChange={(e) => {
                        dispatch(setFormFieldValue(USER_FORM, USER_CONFIRM_EMAIL_FIELD, e.target.value));
                    }}
                    onPaste={(e) => {
                        e.preventDefault();
                    }}
                    errorMessage={inputs[USER_CONFIRM_EMAIL_FIELD].errorMessage}
                />
                <Password controlId={USER_PASSWORD_FIELD} label={<FormattedMessage id="password"/>}
                    isInvalid={!inputs[USER_PASSWORD_FIELD].isValid}
                    value={inputs[USER_PASSWORD_FIELD].value}
                    onChange={(e) => {
                        dispatch(setFormFieldValue(USER_FORM, USER_PASSWORD_FIELD, e.target.value));
                    }}
                    errorMessage={inputs[USER_PASSWORD_FIELD].errorMessage}
                />
                <div className="mt-3 d-flex justify-content-between">
                    <Checkbox
                        controlId={USER_AGREE_TERMS_FIELD}
                        checked={inputs[USER_AGREE_TERMS_FIELD].value}
                        label={<span><FormattedMessage id="agree_terms"/><a href={`/${locale}/show/termeni-si-conditii`} target="_blank"
                            rel="noreferrer">
                            <FormattedMessage id="agree_terms_text"/></a> <FormattedMessage id="agree_terms_website"/></span>}
                        errorMessage={inputs[USER_AGREE_TERMS_FIELD].errorMessage}
                        onChange={(e) => {
                            dispatch(setFormFieldValue(USER_FORM, USER_AGREE_TERMS_FIELD, e.target.checked));
                        }}
                        isInvalid={!inputs[USER_AGREE_TERMS_FIELD].isValid}
                    />
                </div>
                <div className="d-grid mt-4 mb-4">
                    <Button variant="primary" type="submit">
                        <FormattedMessage id="login_modal_email_contiune"/>
                    </Button>
                </div>
                {auth.errorRegister && <p className="text-danger mt-3">{auth.errorRegister}</p>}
            </Form>
        </div>
    );
};
export default LoginStep4;
